/**
 * This plugin has no admin page of its own — every setting lives on
 * Shopware's own generic plugin-config screen (the same one reachable via
 * Settings > Extensions > My extensions > this plugin > Config), rendered
 * by the core `sw-extension` module's `sw.extension.config` route.
 *
 * This module exists purely to put a shortcut to that screen directly in
 * the Marketing menu (requested: "Checkout Konfetti" under Marketing,
 * rather than having to go through Extensions every time).
 *
 * Shopware's ModuleFactory (module.factory.ts registerModule()) refuses to
 * register a module — and therefore never processes its `navigation`
 * either — unless it owns at least one valid route of its own ("Module has
 * no configured routes" / "hasn't a valid route definition"). The `index`
 * route below exists ONLY to satisfy that requirement; nothing ever
 * navigates to it on purpose. The navigation entry points straight at
 * `sw.extension.config` (with this plugin's technical name as the
 * `namespace` param) instead — if a user ever DID land on our own route
 * directly (e.g. a stale bookmark), its `redirect` sends them to the exact
 * same place anyway.
 */
Shopware.Module.register('sellops-thank-you-page-effects', {
    type: 'plugin',
    name: 'sellops-thank-you-page-effects',
    title: 'sellops-thank-you-page-effects.general.mainMenuItem',
    description: 'sellops-thank-you-page-effects.general.description',
    color: '#84c541',
    icon: 'regular-sparkle',

    routes: {
        index: {
            path: 'index',
            redirect: {
                name: 'sw.extension.config',
                params: {
                    namespace: 'SellopsThankYouPageEffects',
                },
            },
            meta: {
                privilege: 'system.plugin_maintain',
            },
        },
    },

    navigation: [
        {
            id: 'sellops-thank-you-page-effects-config',
            label: 'sellops-thank-you-page-effects.general.mainMenuItem',
            color: '#84c541',
            icon: 'regular-sparkle',
            // Points directly at the CORE sw-extension module's own config
            // route (not at our own `index` route above) — same pattern
            // Shopware itself uses for extension-SDK app menu items, see
            // sw-admin-menu's extensionModuleNavigation computed property.
            path: 'sw.extension.config',
            params: {
                namespace: 'SellopsThankYouPageEffects',
            },
            parent: 'sw-marketing',
            privilege: 'system.plugin_maintain',
            position: 200,
        },
    ],
});
